import React from "react";
import { Card } from "react-bootstrap";
import useAuth from "../../contexts/useAuth";
import { EmployeeProvider } from "./contexts/EmployeeContext";
import Dashboard from "./Dashboard";

const EmployeeHome = ({ user, match }) => {
  const { user: loggedInUser } = useAuth();
  const [empId, setEmpId] = React.useState(null);
  React.useEffect(() => {
    let empId = loggedInUser?.id;
    if (match?.params?.id) {
      let empObj = JSON.parse(match?.params?.id);
      if (empObj && "id" in empObj && empObj.id) {
        empId = empObj.id;
      }
    }
    if (user && user?.id) {
      empId = user.id;
    }

    if (empId) {
      setEmpId(empId);
    }
  }, [user, loggedInUser]);

  return (
    <div className="container">
      <EmployeeProvider>
        <Card>
          <Card.Body>
            <Card.Title as="h2" className="mb10">
              Dashboard
            </Card.Title>
            {empId && <Dashboard empId={empId} />}
          </Card.Body>
        </Card>
      </EmployeeProvider>
    </div>
  );
};

export default EmployeeHome;
